<template>
	<div id="Waves">
		<!-- Header -->
		<div class="header py-7 py-lg-8 pt-lg-9">
			<b-container class="container">
				<div class="header-body text-center mb-7">
					<b-row class="justify-content-center">
						<b-col xl="5" lg="6" md="8" class="px-5">
							<h1 class="text-white">Welcome</h1>
							<p class="text-lead text-white">Create an account</p>
						</b-col>
					</b-row>
				</div>
			</b-container>
			<!--      <div class="separator separator-bottom separator-skew zindex-100">-->
			<!--        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">-->
			<!--          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>-->
			<!--        </svg>-->
			<!--      </div>-->
		</div>
		<!-- Page content -->
		<b-container class="mt--8 pb-5">
			<!-- Table -->
			<b-row class="justify-content-center">
				<b-col lg="6" md="8">
					<b-card no-body class="bg-secondary border-0">
						<b-card-header class="bg-transparent pb-5" style="display: none">
							<div class="text-muted text-center mt-2 mb-4"><small>Sign up with</small></div>
							<div class="text-center">
								<a href="#" class="btn btn-neutral btn-icon mr-4">
									<span class="btn-inner--icon"><img src="img/icons/common/github.svg" /></span>
									<span class="btn-inner--text">Github</span>
								</a>
								<a href="#" class="btn btn-neutral btn-icon">
									<span class="btn-inner--icon"><img src="img/icons/common/google.svg" /></span>
									<span class="btn-inner--text">Google</span>
								</a>
							</div>
						</b-card-header>
						<b-card-body class="px-lg-5 py-lg-5">
							<div class="text-center text-muted mb-4">
								<small>sign up with credentials</small>
							</div>
							<validation-observer v-slot="{handleSubmit}" ref="formValidator">
								<b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
									<base-input
										alternative
										class="mb-3"
										prepend-icon="ni ni-hat-3"
										placeholder="Name"
										name="Name"
										:rules="{required: true}"
										v-model="model.name"
									>
									</base-input>

									<base-input
										alternative
										class="mb-3"
										prepend-icon="ni ni-email-83"
										placeholder="Email"
										name="Email"
										:rules="{required: true, email: true}"
										v-model="model.email"
									>
									</base-input>

									<b-form-group label-for="input-1" class="country-code">
										<vue-tel-input
											v-model="model.phone"
											placeholder="201-555-2123"
											:defaultCountry="preferredCountry"
											:enabledCountryCode="enabledCountryCodeStatus"
											:rule="{require: true}"
											:validCharactersOnly="validCharactersOnly"
											@country-changed="onSelect"
										></vue-tel-input>
										<b-form-invalid-feedback :state="phoneNoStatus">
											Please select a valid phone number
										</b-form-invalid-feedback>
									</b-form-group>

									<base-input
										alternative
										class="mb-3"
										prepend-icon="ni ni-lock-circle-open"
										placeholder="password"
										type="password"
										name="Password"
										:rules="{required: true, min: 8}"
										v-model="model.password"
									>
									</base-input>

									<div class="text-muted font-italic">
										<small
											>password strength:
											<span class="text-success font-weight-700">strong</span></small
										>
									</div>
									<b-row class="my-4">
										<b-col cols="12">
											<base-input :rules="{required: {allowFalse: false}}" name="Privacy" Policy>
												<b-form-checkbox v-model="model.agree">
													<span class="text-muted"
														>I agree with the <a href="#!">Privacy Policy</a></span
													>
												</b-form-checkbox>
											</base-input>
										</b-col>
										<b-col cols="12">
											<div
												class="text-center text-primary cursor-pointer text-sm"
												v-on:click="redirectSignin()"
											>
												<i><b>Sign in instead</b></i>
											</div>
										</b-col>
									</b-row>
									<div class="text-center">
										<b-button type="submit" variant="primary" class="mt-4">Create account</b-button>
									</div>
								</b-form>
							</validation-observer>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import {VueTelInput} from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import AuthService from "@/common/api-services/auth-service";
import configDirective from "../../../common/directive/config-directive";

export default {
	name: "register",
	components: {
		VueTelInput,
	},
	computed: {
		phoneNoStatus() {
			return this.model.phone.length > 0;
		},
	},
	data() {
		return {
			model: {
				name: "",
				email: "",
				phone: "",
				password: "",
				agree: false,
			},
			enabledCountryCodeStatus: true,
			dialCode: "",
			preferredCountry: "us",
			validCharactersOnly: true,
			validPhoneNum: true,
			registerStatus: false,
		};
	},
	mounted() {
		let getRegister = configDirective.getRegisterStatus();
		if (!getRegister) {
			this.registerStatus = false;
		} else if (getRegister === false) {
			this.registerStatus = false;
		} else if (getRegister === true) {
			this.registerStatus = true;
		}
		if (!this.registerStatus) {
			this.$router.push({name: "login"});
		}
		this.$root.$emit("renderBackground", true);
	},
	methods: {
		onSubmit() {
			this.model.phone = this.model.phone.replace("(", "").replace(")", "").trim();
			//console.log(this.model)
			let data = btoa(
				this.model.username + "|" + this.model.email + "|" + this.model.phone + "|" + this.model.password
			);
			AuthService.register(data).then(res => {
				this.$toast.success(res)
			});
		},

		onSelect({name, iso2, dialCode}) {
			this.dialCode = dialCode;
			this.model.phone = "+" + dialCode;
		},

		redirectSignin() {
			this.$router.push({name: "login"});
		},
	},
};
</script>
